import React from 'react';
import {connect} from 'dva';
import '@/styles/containers/common/wizModalUserIdentityShow/index.less';
import {component_tool, framework_tool} from '@/tool';
import createColumns from "./columns";
import { Table } from "antd";

const {WizCard, WizDataTable, WizTable, WizModal, WizEmpty, WizButton, WizSpin, WizRow, WizCol} = component_tool;
let {WizContainer, modelUtils} = framework_tool;

/**
 * 查看任职
 */
class WizModalUserIdentityShow extends WizContainer {

  componentName = 'WizModalUserIdentityShow';

  constructor(props) {
    super(props);
    this.state = {
      time: new Date().getTime(),
      modalVisible: props.visible,
      personId: null,
    };
    this.personId = null;
    this.orgId = null;
    this.positionId = null;
    this.personAndUserInfo = {};
    this.userIdentityInfoList = [];
  }

  /**获取对应的线下培训课程数据，线下培训课程选择组件需要显示默认值 */
  getUserPersonInfo() {
    if (this.personId && this.personId != undefined && this.personId != '') {
      this.doAction({
        path: 'personManage/getPersonAndUserIdentitiesInfo',
        payload: {
          key: 'getPersonAndUserIdentitiesInfo@' + this.personId,
          apiParams: {
            personId: this.personId,
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    personAndUserIdentitiesInfo: this._getPersonAndUserIdentitiesInfoOver.bind(this),
    visible: this._visibleOnChange.bind(this),
  };

  /**
   * 打开模态框时查询数据
   * @param {*} nextProps
   * @param {*} nextState
   */
  _visibleOnChange(nextProps, nextState) {
    nextState['time'] = new Date().getTime();
    const {personId, orgId, positionId} = nextProps;
    if (nextProps.visible !== this.state.modalVisible) {
      nextState.modalVisible = nextProps.visible;
      if (nextProps.visible) {
        this.setState({
          personId
        });
        this.personId = personId;
        this.orgId = orgId;
        this.positionId = positionId;
        this.getUserPersonInfo();
      }

    }
    return true
  }

  _userIdentityInfoListOnChange() {
    let personAndUserInfo = this.personAndUserInfo;
    let initOrgId = this.orgId;
    let initPositionId = this.positionId;
    let userIdentityInfoList = [];
    if (personAndUserInfo && personAndUserInfo.userIdentityInfoList) {
      personAndUserInfo.userIdentityInfoList.forEach(userIdentityInfo => {
          const {orgId, positionId, id} = userIdentityInfo;
          userIdentityInfo['key'] = id;
          if (initOrgId && initPositionId) {
            if (initOrgId === orgId && initPositionId === positionId) {
              userIdentityInfoList.push(userIdentityInfo)
            }
          } else if (initOrgId && !initPositionId) {
            if (initOrgId === orgId) {
              userIdentityInfoList.push(userIdentityInfo)
            }
          } else if (!initOrgId && initPositionId) {
            if (initPositionId === positionId) {
              userIdentityInfoList.push(userIdentityInfo)
            }
          } else {
            userIdentityInfoList.push(userIdentityInfo)
          }
        }
      );
    }
    this.userIdentityInfoList = userIdentityInfoList;
  }

  /**
   * 监控用户信息变化，进行渲染
   */
  _getPersonAndUserIdentitiesInfoOver(nextProps, nextState) {
    let personAndUserIdentitiesInfo = nextProps.personAndUserIdentitiesInfo.data;
    if (nextProps.personAndUserIdentitiesInfo.code == 1 && personAndUserIdentitiesInfo) {
      this.personAndUserInfo = personAndUserIdentitiesInfo;
      this._userIdentityInfoListOnChange();
    } else {
      wizNotice.error('获取用户信息失败：' + nextProps.personAndUserIdentitiesInfo.msg);
    }
    return true;
  }


  /**
   * 取消选择
   * @param {*} e
   */
  _onCancel(e) {
    if (this.props.onCancel) {
      this.props.onCancel(e);
      this.setState({
        time: new Date().getTime(),
        personId: null,
      });
    } else {
      this.setState({
        modalVisible: false,
        time: new Date().getTime(),
        personId: null,
      })
    }
    this.personId = null;
    this.orgId = null;
    this.positionId = null;
    this.personAndUserInfo = {};
    this.userIdentityInfoList = [];
  }

  /**
   * 人员基础信息
   * @private
   */
  _userBaseInfo = () => {
    let personAndUserInfo = this.personAndUserInfo;
    let user = {};
    let personInfo = {};
    if (personAndUserInfo && personAndUserInfo.user) {
      user = personAndUserInfo.user;
    }
    if (personAndUserInfo && personAndUserInfo.personInfo) {
      personInfo = personAndUserInfo.personInfo;
    }
    const {userName, fullName, mobile, email, disabled} = user;
    const {idCard, userType, gender} = personInfo;
    let cardProps = {
      title: '人员基本信息',
      icon: 'solution',
      headStyle: {height: 15, fontSize: 14},
      bodyStyle: {marginBottom: 0, paddingBottom: 0},
    };
    return (
      <WizCard {...cardProps} className="wizModalUserIdentityShow-card">
        {!userName ? <WizEmpty image={WizEmpty.PRESENTED_IMAGE_SIMPLE}/> :
          <>
            {this._renderContentRow('账号', userName, '姓名', fullName)}
            {this._renderContentRow('邮箱', email, '用户属性', this._getValue('userType', userType))}
            {this._renderContentRow('性别', this._getValue('gender', gender), '手机号', mobile)}
            {this._renderTitleInfoRowAll('状态', this._getValue('disabled', disabled))}
          </>
        }
      </WizCard>
    )
  };

  _getValue(type, key) {
    const values = {
      gender: {
        0: '男',
        1: '女',
        2: '未知',
      },
      userType: {
        0: '培训平台用户',
        3: 'OEM部门用户',
        4: '经销商用户',
        5: '服务商用户'
      },
      state: {
        1: '激活',
        0: '禁用'
      },
      disabled: {
        1: '禁用',
        0: '激活'
      }

    };
    return values[type][key]
  };

  _renderContentRow(ln, lv = '', rn, rv = '') {
    return (
      <WizRow className="row-style-1">
        <WizCol className="col-float-right" span={3} offset={1}>{ln + '：'}</WizCol>
        <WizCol span={6}>{lv}</WizCol>
        <WizCol className="col-float-right" span={3} offset={2}>{rn + '：'}</WizCol>
        <WizCol span={8}>{rv}</WizCol>
      </WizRow>
    )
  }

  _renderTitleInfoRowAll(leftName, leftValue = '') {
    return (
      <WizRow className='row-style-1'>
        <WizCol className='col-float-right' span={3} offset={1}>{leftName + '：'}</WizCol>
        <WizCol span={6}>{leftValue}</WizCol>
      </WizRow>
    )
  }
  /**
   * 人员任职信息
   * @private
   */
  _userIdentityInfo = () => {
    const {personManageLoading} = this.props;
    let columns = createColumns(this);
    //获取需要展示的数据
    let userIdentityInfoList = this.userIdentityInfoList;
    let dataTableProps = {
      loading: false,
      columns,
      dataSource: userIdentityInfoList,
      bordered: false,
      locale: <WizEmpty image={WizEmpty.PRESENTED_IMAGE_SIMPLE}/>,
      tableLayout:'fixed',
      scroll:{
        x:true,
      },
      pagination:{
        position:['bottomCenter']
      },
    };
    let cardProps = {
      title: '任职信息',
      icon: '0',
      headStyle: {height: 15, fontSize: 14},
      bodyStyle: {marginBottom: 0, paddingBottom: 0},
    };
    return (
      <WizCard {...cardProps} className="wizModalUserIdentityShow-card">
        <Table className="table-style-class" key={'table@'+this.state.personId} rowKey={record => record.id} {...dataTableProps}/>
      </WizCard>
    )
  };

  _render() {
    const {personManageLoading} = this.props;
    let {title, width} = this.props;
    return (
      <WizModal
        key={this.personId + '@' + this.state.time}
        visible={this.state.modalVisible}
        title={title || '查看任职'}
        width={width || 950}
        onCancel={e => this._onCancel(e)}
        footer={<WizButton onClick={e => this._onCancel(e)}>关 闭</WizButton>}
      >
        <WizSpin tip={'加载中'} spinning={personManageLoading}>
          {this._userBaseInfo()}
          {this._userIdentityInfo()}
        </WizSpin>
      </WizModal>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  const {personManage} = state;
  const personAndUserIdentitiesInfo = modelUtils.getModelEntity(personManage, "getPersonAndUserIdentitiesInfo@" + ownProps.personId);
  const load = modelUtils.getLoadingState(state, ['personManage']);
  return {
    personAndUserIdentitiesInfo: personAndUserIdentitiesInfo,
    ...load
  }
};
export default connect(mapStateToProps)(WizModalUserIdentityShow);
